<template>
  <div class="page_updateInvoice">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>收支</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/invoicing' }">结算单</el-breadcrumb-item>
          <el-breadcrumb-item>申请开票</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="p_employee_box" v-loading="tableLoading">
        <div class="p_employee_list">
          <el-form :rules="formRules" :inline="true" ref="statementForm" :model="formQuery" label-width="80px">
            <el-form-item label="归属:" prop="type">
              <div class="i_radio_box">
                <el-radio-group v-model="formQuery.type">
                  <el-radio :label="1">项目</el-radio>
                  <el-radio :label="2" v-if="userLabel != 'K'">申请人所在部门</el-radio>
                </el-radio-group>
                <div class="i_box">
                  <el-select v-model="formQuery.ownershipId" v-if="formQuery.type == 1" placeholder="请选择项目" size="small" @change="getDetail" filterable clearable style="width: 140px">
                    <el-option v-for="item in projectList" :key="item.Id" :label="item.StrprojectName" :value="item.Projectid"></el-option>
                  </el-select>
                  <el-cascader v-if="formQuery.type == 2" v-model="dedpartDiaVal" size="small" :props="props" clearable filterable :options="departList" placeholder="请选择部门" @change="departChange" style="width: 140px"></el-cascader>
                </div>
              </div>
            </el-form-item>
            <el-form-item :label="formQuery.type==1 ? '商务合同主体:' : '法务主体:'" label-width="125px" prop="subjectOfLegalAffairsId">
              <el-select v-model="formQuery.subjectOfLegalAffairsId" placeholder="" size="small" style="width: 320px" clearable filterable @change="changeLeg">
                <el-option v-for="(item, index) in legList" :key="index" :label="item.value" :value="item.key"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户名称:" v-if="formQuery.type == 1">
              <span>{{ custname }}</span>
            </el-form-item>
            <el-form-item label="账户类别:">
              <el-radio-group v-model="formQuery.xAccount.accountType" @input="changeAccountType">
                <el-radio :label="0">基本户</el-radio>
                <el-radio :label="1">一般户</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="销方开户行/账号:" v-if="formQuery.xAccount.accountType==1" label-width="140px">
              <el-select v-model="formQuery.xAccount.bankAccount" placeholder="" size="small" @change="changeBankAccount" filterable clearable style="width: 300px">
                <el-option v-for="item in accountList" :key="item.value" :label="item.key" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div v-for="(inv,i) in formQuery.details" :key="i">
          <div v-if="i!=0" class="splitLine"></div>
          <!-- 开票抬头 -->
          <div class="p_employee_list mt15">
            <div class="flex aic">
              <div class="r_edit_title">
                <div class="line_box"></div>
                第一步：填写开票抬头
              </div>
              <div class="tips" v-if="i==0">说明：可在项目账套中添加好客户开票抬头，系统自动读取</div>
            </div>
            <div class="com_style pt20 mt15">
              <el-form :model="formQuery" :inline="true" :rules="formRules" ref="statementForm1" label-width="110px">
                <el-form-item label="开票抬头:" prop="details[0].invoiceTitle" v-if="inv.isNaturalPerson!=1">
                  <el-select v-model="invoiceTitle[i]" placeholder="" size="small" clearable filterable @change="(val) => changeInvoiceTitle(val, inv)" value-key="id" style="width: 320px;">
                    <el-option v-for="(item, index) in invoiceTitles" :key="index" :label="item.accountName" :value="item"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-checkbox v-model="inv.isNaturalPerson" :true-label="1" :false-label="0" style="margin-left: 20px" @change="(val) => changeIsp(val, i)">是否自然人</el-checkbox>
                </el-form-item>
                <el-form-item label="使用新抬头:">
                  <el-input v-model="inv.newInvoiceTitle" @change="(val) => changeNewTitle(val, inv)" size="small" clearable></el-input>
                </el-form-item>
                <el-form-item label="纳税人识别号:" prop="details[0].ratepayerNo" v-if="inv.isNaturalPerson!=1">
                  <el-input v-model="inv.ratepayerNo" size="small" clearable></el-input>
                </el-form-item>
                <el-form-item label="营业地址:" v-if="inv.isNaturalPerson!=1">
                  <el-input v-model="inv.businessAddress" size="small" clearable></el-input>
                </el-form-item>
                <el-form-item label="开户行:" v-if="inv.isNaturalPerson!=1">
                  <el-input v-model="inv.bankOfDeposit" size="small" clearable></el-input>
                </el-form-item>
                <el-form-item label="账号:" v-if="inv.isNaturalPerson!=1">
                  <el-input v-model="inv.accountNumber" size="small" clearable></el-input>
                </el-form-item>
                <el-form-item label="电话:" v-if="inv.isNaturalPerson!=1">
                  <el-input v-model="inv.telephone" size="small" clearable></el-input>
                </el-form-item>
              </el-form>
            </div>
          </div>

          <div class="p_employee_list mt15">
            <div class="r_edit_title">
              <div class="line_box"></div>
              第二步：填写开票内容
            </div>
            <div class="com_style pt20 mt15">
              <div class="merge flex">
                <el-checkbox v-model="inv.isConsolidatedBilling" :true-label="1" :false-label="0" @change="(val) => { changeConsolidatedBilling(val, inv) }">服务费/管理费与工资/社保/个税合开在一张发票上（仅适用差额开票）</el-checkbox>
              </div>
              <el-table class="i_list" border :data="inv.invoiceDetailList" style="width:100%">
                <el-table-column align="center" label="发票项目" min-width="120px">
                  <template slot-scope="{row}">
                    <div class="flex" style="flex-wrap: nowrap;">
                      <span class="req">*</span>
                      <el-select v-model="row.invoiceItem" placeholder="" size="small" @change="(val)=>{changeInvoiceItem(val,row,i)}" style="width: 110px;">
                        <el-option label="服务费" :value="1"></el-option>
                        <el-option label="劳务费" :value="2"></el-option>
                        <el-option label="管理费" :value="3"></el-option>
                        <el-option label="工资" :value="-1"></el-option>
                        <el-option label="社保" :value="-2"></el-option>
                        <el-option label="公积金" :value="-3"></el-option>
                        <el-option label="个税" :value="-4"></el-option>
                      </el-select>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="发票类型" min-width="120px" fit>
                  <template slot-scope="{row}">
                    <div class="flex" style="flex-wrap: nowrap;">
                      <span class="req">*</span>
                      <el-select v-model="row.ticketTypeId" placeholder="" size="small" @change="(val)=>{changeTicketType(val,row,i)}" style="width: 110px;">
                        <el-option v-for="item in ticketTypeList" :key="item.key" :label="item.value" :value="item.key"></el-option>
                      </el-select>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="开票内容" min-width="190px" fit>
                  <template slot-scope="{row,$index}">
                    <div class="flex" style="flex-wrap: nowrap;">
                      <span class="req">*</span>
                      <el-select v-model="row.billingItemDetailsId" placeholder="" size="small" @change="(val)=>{changeBillingItemDetailsId(val,row,i)}" style="min-width: 170px;" filterable>
                        <el-option v-for="item in BillingConList" :key="item.key" :label="item.value" :value="item.key"></el-option>
                      </el-select>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="开票金额" min-width="210px" fit>
                  <template slot-scope="{row}">
                    <div class="flex" style="flex-wrap: nowrap;">
                      <span class="req">*</span>
                      <el-select v-model="row.taxInclusiveLabel" placeholder="" size="small" style="width: 88px;margin-right: 5px" @change="(val)=>{changeTaxInc(val,i)}">
                        <el-option label="含税" :value="1"></el-option>
                        <el-option label="不含税" :value="0"></el-option>
                      </el-select>
                      <el-input v-model="row.applyForAmount" type="number" size="small" style="width: 110px" @blur="getInvPrice(i,'ccc')"></el-input>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="数量" min-width="80px" fit>
                  <template slot-scope="{row}">
                    <el-input v-model="row.quantity" type="number" size="small" style="width: 70px"></el-input>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="单位" min-width="80px" fit>
                  <template slot-scope="{row}">
                    <el-input v-model="row.unit" size="small" style="width: 70px"></el-input>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="规格" min-width="100px" fit>
                  <template slot-scope="{row}">
                    <el-input v-model="row.specification" size="small" style="width: 75px"></el-input>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="" width="100px" fixed="right">
                  <template slot-scope="{row,$index}">
                    <div class="injuryTabBtn">
                      <el-button type="text" @click="addContentHandle(row,i)">+ 添加</el-button>
                      <el-button type="text" v-if="$index!=0" @click="dltContentHandle($index,i)">删除</el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <div class="kptip">
                提示：工资/社保/个税只能开普票
              </div>
              <div class="sumAmount">价税合计：￥{{ applyForAmount[i].sum }}</div>
            </div>

            <div class="pt20 mt15" v-if="viewBuild[i]">
              <div class="tips" v-if="i==0">说明：仅在开票内容选择 ‘建筑服务’ 时填写</div>
              <el-form :model="formQuery" :inline="true" :rules="formRules" label-width="160px">
                <el-form-item label="土地增值税项目编号:">
                  <el-input v-model="inv.buildingData.landValueTaxNo" size="small" clearable></el-input>
                </el-form-item>
                <el-form-item label="建筑服务发生地:">
                  <el-input v-model="inv.buildingData.buildingServiceSite" size="small" clearable></el-input>
                </el-form-item>
                <el-form-item label="详细地址:">
                  <el-input v-model="inv.buildingData.detailedAddress" size="small" clearable></el-input>
                </el-form-item>
                <el-form-item label="建筑项目名称:">
                  <el-input v-model="inv.buildingData.buildingName" size="small" clearable></el-input>
                </el-form-item>
                <el-form-item label="跨地市标志:">
                  <el-select v-model="inv.buildingData.crossCitySigns" placeholder="" size="small" clearable filterable>
                    <el-option label="是" :value="1"></el-option>
                    <el-option label="否" :value="0"></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </div>

            <!-- 选择结算单 -->
            <div class="flex aic" style="margin-top: 15px;">
              <div class="r_edit_title">
                <div class="line_box"></div>
                第三步：选择结算单
              </div>
              <div class="redTips">结算单至少勾选一条，且合计开票金额需等于价税合计</div>
            </div>
            <div class="post_list mt15">
              <el-table border @selection-change="(val) => handleSelectionChange(val,i)" :data="finalStatement[i].list" ref="multipleTable" class="doc_table" style="width: 100%">
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <!-- 项目或部门 -->
                <el-table-column align="center" prop="ownershipName" label="项目" min-width="140px">
                </el-table-column>
                <el-table-column align="center" prop="ownershipMonth" label="归属月" min-width="100px" fit :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column align="center" prop="finalStatementNo" label="结算单编号" min-width="120px" fit :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column align="center" prop="amount" label="结算单金额" min-width="100px" fit :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column align="center" prop="remaining" label="剩余待开金额" min-width="110px" fit :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column align="center" label="本次开具金额" width="160px" fit :show-overflow-tooltip="true">
                  <template slot-scope="{ row }">
                    <span class="req">*</span>
                    <el-input type="number" v-model="row.ttAmount" size="small" @blur="changeTTAmount(i)" clearable style="width:110px"></el-input>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="创建时间" min-width="120px" fit :show-overflow-tooltip="true">
                  <template slot-scope="{ row }">
                    <span>{{
            row.createTime ? row.createTime.replace("T", " ") : ""
          }}</span>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="附件" min-width="100px" fit :show-overflow-tooltip="true">
                  <template slot-scope="{row}">
                    <div class="blueName cp" v-for="(item,index) in row.files" :key="index" @click="down(item.fileUrl,item.fileName)">{{ item.fileName }}</div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <!-- <div class="add_box flex">
              <el-select v-model="formQuery.Projectid" placeholder="请选择项目" size="small" @change="changePro2" filterable clearable>
                <el-option v-for="item in projectList" :key="item.Id" :label="item.StrprojectName" :value="item.Projectid"></el-option>
              </el-select>
              <el-button type="primary" class="btn01" size="small" plain @click="addProHandle">+ 可继续添加多项目合并开票</el-button>
            </div> -->
            <div class="com_style mt15 f_com_box">
              <div class="flex_box flex">
                <div class="f_list_box flex">
                  <div class="f_left_box">合计开票金额:</div>
                  <div class="f_right_box">￥{{ settlementAmountSum[i].sum.toFixed(2) }}</div>
                </div>
                <div class="f_list_box flex">
                  <div class="f_left_box">结算单:</div>
                  <div class="f_right_box">
                    <i class="el-icon-document f_icon"></i>
                  </div>
                </div>
                <div class="f_list_box flex">
                  <div class="f_left_box">客户扣款金额:</div>
                  <div class="f_right_box">
                    <el-input v-model="inv.deductionAmount" size="small" clearable></el-input>
                  </div>
                </div>
              </div>
            </div>
            <div class="com_style mt15 f_com_box f_foot_box">
              <div class="f_foot_box flex">
                <el-checkbox v-model="inv.isInvoiceMail" :true-label="1" :false-label="0">是否自动邮件发送电子/数电发票</el-checkbox>
                <div class="flex f_foot">
                  <div class="foot_left_box">接收邮箱</div>
                  <div class="flex">
                    <el-select v-model="inv.projectEmailIds" placeholder="" size="small" multiple filterable @change="changeEmail" style="width: 300px">
                      <el-option v-for="(item, index) in emailList" :key="index" :label="item.value" :value="item.key"></el-option>
                    </el-select>
                    <el-input class="t_sel" v-model="inv.newEmail" size="small" placeholder="输入其他电子邮箱" clearable></el-input>
                  </div>
                </div>
                <div class="kptip">可添加多个邮箱，用英文格式的“;”隔开，如aaa@jobstart.cn;bbb@jobstart.cn</div>
              </div>
              <div class="f_foot_box flex mt15">
                <el-checkbox v-model="inv.isStatementMail" :true-label="1" :false-label="0">费用结算单盖章一并电子邮件发送</el-checkbox>
                <div class="flex f_foot">
                  <el-upload class="upload-demo" ref="file" action="#" :on-change="success_handle" :auto-upload="false" :limit="5" :on-remove="handleFileRemove" :on-exceed="handleExceed" :file-list="stateFileList[i]">
                    <el-button size="small" type="primary">上传结算单</el-button>
                  </el-upload>
                </div>
              </div>
            </div>
          </div>
          <div class="p_employee_list mt15">
            <el-form :inline="true" label-width="90px">
              <el-form-item label="开票备注:" prop="billingNote">
                <el-input v-model="inv.billingNote" type="textarea" :autosize="{ minRows: 1}" size="small" clearable style="width: 300px;"></el-input>
                <div class="tips" style="
                margin-left: 0;">注：显示在发票上</div>
              </el-form-item>
              <el-form-item label="申请备注:" prop="remark">
                <el-input v-model="inv.remark" type="textarea" :autosize="{ minRows: 3}" size="small" clearable style="width: 300px;"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <!-- <el-button type="success" size="small" style="margin: 0 0 10px 20px;" @click="invView(i)">发票预览</el-button> -->
        </div>
        <div class="flex">
          <div class="applyMore blueName cp" v-if="jumpType == 'apply'" @click="applyMore">+申请再开一张发票</div>

          <div class="applyMore deleteBtn cp" v-if="formQuery.details.length>1" @click="delItem()">
            <i class="el-icon-delete delete_icon"></i>
            删除
          </div>
        </div>
        <!-- 申请开票过来 -->
        <div class="btn_box" v-if="jumpType == 'apply' || jumpType == 'edit'">
          <el-button type="success" @click="submit(1)" :loading="isBtnLoading" :disabled="isSuccess">保存为草稿</el-button>
          <el-button type="primary" @click="submit(0)" :loading="isBtnLoading" :disabled="isSuccess">提交申请</el-button>
          <el-button @click="backHandle">返 回</el-button>
        </div>
        <!-- 开票无申请 -->
        <div class="btn_box" v-if="jumpType == 'noApply'">
          <el-button type="success" @click="submit(2)">在线开票</el-button>
          <el-button type="primary">登记手工开票</el-button>
          <el-button @click="backHandle">取消</el-button>
        </div>
      </div>
    </div>

    <el-dialog title="登录" :visible.sync="showLogin" width="640px" class="res_dialog enter_dialog">
      <el-form :model="loginForm" :rules="loginRules" ref="loginForm" class="re_down_form" label-width="100px">
        <el-form-item label="法务主体:">
          {{ loginForm.qymc }}
        </el-form-item>
        <el-form-item label="税号:">
          <!-- {{ loginForm.nsrsbh }} -->
          <el-input v-model="loginForm.nsrsbh" size="small" clearable style="width: 300px"></el-input>
        </el-form-item>
        <!-- <el-form-item label="手机号:" prop="zrrsjh">
          <el-select v-model="listQuery.projectid" size="small" filterable clearable placeholder="" style="width: 180px;">
            <el-option v-for="(item, index) in projectList" :key="index" :label="item.StrprojectName" :value="item.StrprojectName">
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="手机号:" prop="zrrsjh">
          <el-input v-model="loginForm.zrrsjh" size="small" clearable style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="登录密码:" prop="zrrmm">
          <el-input v-model="loginForm.zrrmm" size="small" clearable style="width: 300px"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showLogin = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmLogin" size="small" :loading="isBtnLoading">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="认证" :visible.sync="showAuthentication" width="450px">
      <div :loading="qrLoading">
        <el-form>
          <el-form-item label="二维码类型:">
            <el-select v-model="ewmlx" size="small" @change="changeEwmlx" placeholder="" style="width: 180px;">
              <el-option label="税务APP" :value="1">
              </el-option>
              <el-option label="个税APP" :value="2">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <el-image style="width: 300px; height: 300px;margin-left:50px" v-if="QRCodeSrc" :src="QRCodeSrc" alt=""></el-image>
      <div class="qrTips" v-if="ewmlx">请使用{{ewmlx==1?'税务APP' : '个税APP'}}扫码认证</div>
    </el-dialog>

    <el-dialog title="发票预览" :visible.sync="showInvView" width="1000px">
      <div class="tabBox" v-if="showInvView">
        <div class="invTitle">
          <div class="invType"></div>
          <div class="centerTitle">
            <div class="reimbursementTitle">电子发票{{ ticketType=='普票' ? '普通发票'  : '增值税专业发票'}}</div>
            <hr :width="ticketType=='普票' ? '220px' : '300px'" color="#800000" style="margin-top:-1px;border-color:#800000;" height="1px">
            <hr :width="ticketType=='普票' ? '220px' : '300px'" color="#800000" style="margin-top:-5px;border-color:#800000;" height="1px">
          </div>
          <div style="min-width: 150px;">
            <div><span class="invNum">发票号码：</span>XXXXXXX</div>
            <div><span class="invNum">开票日期：</span>XXXXXXX</div>
          </div>
        </div>
        <table width="100%" border="0" cellspacing="1" cellpadding="4" class="invoiceTable" align="center">
          <tr>
            <td width="2.5%" class="font-center titfont">购买方信息</td>
            <td colspan="19">
              <div>
                <div class="rowItem">
                  <span class="rowTitle">名称：</span>
                  安德利集团有限公司
                </div>
                <div class="rowItem mt">
                  <span class="rowTitle">统一社会信用代码/纳税人识别号：</span>
                  91330382145546231P
                </div>
              </div>
            </td>
            <td width="2.5%" class="font-center titfont">销售方信息</td>
            <td colspan="19">
              <div>
                <div class="rowItem">
                  <span class="rowTitle">名称：</span>
                  安德利集团有限公司
                </div>
                <div class="rowItem mt">
                  <span class="rowTitle">统一社会信用代码/纳税人识别号：</span>
                  91330382145546231P
                </div>
              </div>
            </td>
          </tr>

          <tr>
            <td colspan="40">
              <div class="invInfoBox">
                <div class="flex">
                  <div class="invItem" style="width: 140px;">项目名称</div>
                  <div class="invItem">规格型号</div>
                  <div class="invItem" style="width: 80px;">单&nbsp;&nbsp;&nbsp;&nbsp;位</div>
                  <div class="invItem" style="width: 80px;">数&nbsp;&nbsp;&nbsp;&nbsp;量</div>
                  <div class="invItem">单&nbsp;&nbsp;&nbsp;&nbsp;价</div>
                  <div class="invItem">金&nbsp;&nbsp;&nbsp;&nbsp;额</div>
                  <div class="invItem">税率/征收率</div>
                  <div class="invItem">税&nbsp;&nbsp;&nbsp;&nbsp;额</div>
                </div>
                <div class="invInfoLine flex">
                  <div style="width: 500px;">*人力资源服务*劳务费</div>
                  <div class="invInfoItem">369031.22</div>
                  <div class="invInfoItem">13%</div>
                  <div class="invInfoItem">47974.06</div>
                </div>
                <div class="invInfoBot flex">
                  <div class="invItem" style="width: 200px;">合&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;计</div>
                  <div style="width: 300px;"></div>
                  <div class="invInfoItem">￥369031.22</div>
                  <div class="invInfoItem"></div>
                  <div class="invInfoItem">￥47974.06</div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="40">
              <div class="amountLine flex">
                <div class="invItem" style="width: 200px;border-right: 1px solid #800000;">价税合计（大写）</div>
                <div style="width: 300px;">ⓧ肆拾壹万柒仟零伍圆贰角捌分</div>
                <div>
                  <span>（小写）</span>
                  ￥417005.28
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td width="2.5%" class="font-center titfont titfont2">备 注</td>
            <td colspan="39">
              <div class="invRemake">销方开户银行:宁波银行大榭支行; 银行账号:54010122000161635;</div>
              <div class="invRemake">9月</div>
            </td>
          </tr>
        </table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showInvView = false" size="small">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import xz from "@/common";
  import moment from "moment";
  import print from "print-js";
  import datas from "../../store/mainArea";
  import {
    number,
    row
  } from "mathjs";
  export default {
    name: "updatePost",
    data() {
      var validatetInvoiceTitle = (rule, value, callback) => {
        if (!this.formQuery.details[0].invoiceTitle && !this.formQuery.details[0].newInvoiceTitle) {
          callback(new Error("请选择开票抬头"));
        } else {
          callback();
        }
      };
      return {
        custname: "", //客户名称
        invoiceTitles: [], //抬头列表
        invoiceTitle: [''], //选择的抬头
        BillingList: [], //开票方式列表
        BillingConList: [], //开票内容列表
        Billing: "",
        Billing2: "",
        businessTypeId: "", //业务类型
        finalStatement: [{
          list: []
        }], //结算单列表
        finalStatement2: [], //要合并的列表
        settlementAmountSum: [{
          sum: 0
        }], //合计开票金额
        ticketTypeList: [], //票种列表
        billingItemDetails: "", //开票内容
        billingItemDetails2: '',
        ticketTypeList2: [],
        emailList: [], //邮箱列表
        typeInvoice: "", //票种
        formQuery: {
          type: 1,
          ownershipId: "", //归属id
          subjectOfLegalAffairsId: "", //开票主体id
          xAccount: {
            accountType: 0, //账户类别0：基本户1：一般户
            openingBank: '',
            bankAccount: '',
          },
          details: [{
            isNaturalPerson: 0, //1是0否
            invoiceTitle: "", //开票抬头id
            newInvoiceTitle: "", //新开票抬头
            ratepayerNo: "", //纳税人识别号
            businessAddress: "", //营业地址
            bankOfDeposit: "", //开户行
            accountNumber: "", //账号
            telephone: "", //电话
            isConsolidatedBilling: 0, //是否合并开票
            isStatementMail: 0, //费用结算单盖章一并邮寄0：否1：是
            isInvoiceMail: 0, //是否自动邮件发送电子/数电发票0：否1：是
            remark: "", ////备注
            deductionAmount: 0, //客户扣款金额
            newEmail: "", //新邮箱
            projectEmailIds: [
              //发票邮箱集合
            ],
            invoiceFiles: [
              //发票结算单文件地址
            ],
            buildingData: { //建筑服务补充信息
              landValueTaxNo: "", //土地增值税项目编号
              buildingServiceSite: "", //建筑服务发生地
              detailedAddress: "", //详细地址
              buildingName: "", //建筑项目名称
              crossCitySigns: 1 //跨地市标志1:是0：否
            },
            invoiceId: "", ////发票id
            billingNote: '', //开票备注
            invoiceForFinalStatementsList: [{
              //关联结算单
              finalStatementId: "", //
              amount: 0,
              invoiceForFinalStatementId: '', //结算单关联id
            }],
            invoiceDetailList: [{
              invoiceDetailsId: '', //开票申请详细id
              invoiceItem: null, //发票项目
              ticketTypeId: '', //票种id
              billingItemDetailsId: '', //开票内容id
              taxInclusiveLabel: 1, //是否含税1：含税0：不含税
              applyForAmount: 0, //申请金额
              quantity: null, //数量
              unit: '', //单位
              specification: '' //规格
            }],
          }],
          status: 0, //状态 0申请提交 1申请保存 2开票提交
          founder: Cookies.get("userid-b"), //创建人
        },
        accountList: [],
        legList: [],
        applyForAmount: [{
          sum: 0
        }],
        times: 0,
        rate: 0,
        taxInclusiveLabel: 1,
        userLabel: localStorage.userLabel,
        kcamount: '', //扣除金额
        showAuthentication: false,
        QRCodeSrc: '',
        ewmlx: null,
        qrLoading: false,
        formRules: {
          type: {
            required: true,
            message: "请选择归属",
            trigger: "change",
          },
          subjectOfLegalAffairsId: {
            required: true,
            message: "请选择法务实体",
            trigger: "change",
          },
          'details[0].invoiceTitle': {
            required: true,
            validator: validatetInvoiceTitle,
            message: "请选择开票抬头",
            trigger: "change",
          },
          'details[0].ratepayerNo': {
            required: true,
            message: "请输入纳税人识别号",
            trigger: "blur",
          },
          'details[0].businessAddress': {
            required: true,
            message: "请输入营业地址",
            trigger: "blur",
          },
          'details[0].bankOfDeposit': {
            required: true,
            message: "请输入开户行",
            trigger: "blur",
          },
          'details[0].accountNumber': {
            required: true,
            message: "请输入账号",
            trigger: "blur",
          },
          'details[0].telephone': {
            required: true,
            message: "请输入电话",
            trigger: "blur",
          },

        },
        projectList: [], //项目列表
        departList: [], //部门列表
        dedpartDiaVal: [],
        stateFileList: [
          []
        ],
        showLogin: false,
        loginForm: {},
        isSuccess: false,
        loginRules: {
          zrrsjh: {
            required: true,
            message: "请输入登录手机",
            trigger: "blur",
          },
          zrrmm: {
            required: true,
            message: "请输入登录密码",
            trigger: "blur",
          },
        },
        tableLoading: false,
        isBtnLoading: false,
        jumpType: "apply",
        // 详情参数
        dtlQuery: {
          mainuserid: "",
          useridr: "",
        },
        props: {
          label: "strorganname",
          value: "strorgancode",
          children: "children",
          checkStrictly: true,
        },
        tableData: [{
          Strtoppowername: "",
          num: "",
        }, ],
        multipleSelection: [], //结算单多选数据
        viewBuild: [false],
        invoiceData: [{
          name: "",
          num: '',
          piao: '',
          content: '',
          type: 0,
        }],
        showInvView: false,
        xsInfo: {
          title: '',
          ratepayerNo: '',
        },
      };
    },
    created() {
      if (this.$route.query.type) {
        this.jumpType = this.$route.query.type;
        if (this.jumpType == "single" || this.jumpType == "edit") {
          this.id = this.$route.query.id;
          this.GetInvoiceEdit(this.id);
        }
      }
      this.getProNameList();
      // 部门列表
      this.getDepartList();
      // this.getlegalsubjectlist();
      // this.getQRStatus('07c694671f4f46d68846da054885da7b');
    },
    methods: {
      // 新增开票其他部分
      addContentHandle(row, i) {
        if (this.formQuery.details[0].invoiceDetailList[0].ticketTypeId && this.formQuery.details[0].invoiceDetailList[0].billingItemDetailsId) {
          let query = {
            invoiceDetailsId: '', //开票申请详细id
            invoiceItem: null, //发票项目
            ticketTypeId: '', //票种id
            billingItemDetailsId: '', //开票内容id
            taxInclusiveLabel: 1, //是否含税1：含税0：不含税
            applyForAmount: 0, //申请金额
            quantity: null, //数量
            unit: '', //单位
            specification: '' //规格
          };
          this.formQuery.details[i].invoiceDetailList.push(query);
        } else {
          this.$message.warning('请先完善第一行信息')
        }
      },
      // 删除开票其他部分
      dltContentHandle(index, i) {
        // console.log(index, i)
        this.formQuery.details[i].invoiceDetailList.splice(index, 1);
        // this.changeTTAmount(i)
        this.getInvPrice(i, 'ccc')
      },
      // 获取部门列表
      getDepartList() {
        xz.getorganstr('', localStorage.loginRoletype, {
          strIsDisable: 1
        }).then(res => {
          if (res.status == 'ok') {
            this.departList = res.msg.parent[0].children
          } else {
            this.departList = []
          }
        })
      },
      //获取法务主体列表
      getlegalsubjectlist() {
        let data = {
          keyWord: "",
          pageSize: "10000",
          UserId: Cookies.get("userid-b")
        };
        xz.BasicFun(data, "GetSubjectOfLegalAffairs").then((res) => {
          if (res.status == "ok") {
            this.legList = res.data;
          } else {
            this.legList = [];
          }
        });
      },
      // 新增结算单
      addProHandle() {
        this.finalStatement = this.finalStatement.concat(this.finalStatement2);
        this.finalStatement2 = [];
      },
      departChange(val) {
        if (val) {
          this.formQuery.ownershipId = val[val.length - 1];
          this.getDetail("");
        } else {
          this.formQuery.ownershipId = "";
        }
      },
      handleExceed() {
        this.$message.warning(`当前限制最多上传 5 个文件`);
      },
      // 删除结算单
      handleFileRemove() {},
      // 上传结算单
      success_handle(file) {
        const formData = new FormData();
        formData.append("pagename", "docinf");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("excel", file.raw, file.name);
        // console.log("formData", formData);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.formQuery.invoiceFiles.push(res);
          } else {}
        });
      },
      // 表格多选
      handleSelectionChange(val, i) {
        // console.log('this.handleSelectionChange(this.finalStatement[0].list, 0)', val, i)
        if (val[0] != undefined) {
          this.multipleSelection = val;
          let sum = 0;
          this.formQuery.details[i].invoiceFiles = [];
          this.stateFileList[i] = [];
          this.formQuery.details[i].invoiceForFinalStatementsList = [];
          this.multipleSelection.forEach((element) => {
            this.formQuery.details[i].invoiceFiles = this.formQuery.details[i].invoiceFiles.concat(element.files);
            this.stateFileList[i] = this.stateFileList[i].concat(element.files);
            sum = Number(sum) + Number(element.ttAmount);
            let d = {
              finalStatementId: element.finalStatementId,
              amount: Number(element.ttAmount),
              invoiceForFinalStatementId: ''
            };
            this.formQuery.details[i].invoiceForFinalStatementsList.push(d);
          });
          this.stateFileList[i].forEach(element => {
            this.$set(element, 'url', element.fileUrl)
            this.$set(element, 'name', element.fileName)
          });
          this.$nextTick(() => {
            this.settlementAmountSum[i].sum = sum;
            // console.log(this.settlementAmountSum)
          })
        }
      },
      changeTTAmount(i) {
        let sum = 0;
        this.formQuery.details[i].invoiceForFinalStatementsList = [];
        this.multipleSelection.forEach((element) => {
          sum = Number(sum) + Number(element.ttAmount);
          let d = {
            finalStatementId: element.finalStatementId,
            amount: Number(element.ttAmount),
            invoiceForFinalStatementId: ''
          };
          this.formQuery.details[i].invoiceForFinalStatementsList.push(d);
        });
        this.settlementAmountSum[i].sum = sum;
      },
      // 获取项目列表
      getProNameList() {
        let data = {
          projectname: "", // 项目名称
          projectid: "", // 项目id
          custname: "", //客户名称
          strAchieveowner: "", // 业绩归属人
          strservuserid: "", // 客服
          strBusiStat: "", //项目状态
          strpartner2: "", //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: "",
          roletype: localStorage.loginRoletype,
        }
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.projectList = res.msg;
          } else {
            this.projectList = [];
          }
        });
      },
      //打印
      printClick(id, ignoreIds) {
        const style = ".page {margin:0 10mm};"; //打印时去掉眉页眉尾
        setTimeout(function () {
          printJS({
            printable: id, // 标签元素id
            type: "html",
            targetStyles: ["*"],
            style: `.page{margin:10px;height:2000px};table{border-collapse:separate}`,
          });
        }, 500);
      },
      // 取消
      backHandle() {
        // this.$router.push({
        //   path: "/invoicing",
        // });
        window.close()
      },
      isNull(o) {
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == 0 ||
          o == "NaN"
        );
      },
      //初始化
      getDetail(type) {
        if (this.formQuery.ownershipId) {
          let data = {
            type: this.formQuery.type,
            ownershipId: this.formQuery.ownershipId,
            invoiceId: this.id
          };
          xz.IvoiceFun(data, "GetInvoiceLoadEdit").then((res) => {
            if (res.status == "ok") {
              this.custname = res.data.strCustName;
              this.invoiceTitles = res.data.invoiceTitles;
              this.finalStatement[0].list = res.data.finalStatement;
              this.emailList = res.data.projectEmail;
              this.legList = res.data.subjectOfContract;
              if (type == "edit") {
                // this.invoiceTitle = []
                this.invoiceTitles.forEach(element => {
                  if (this.formQuery.details[0].invoiceTitle == element.id) {
                    this.$nextTick(() => {
                      this.invoiceTitle[0] = element;
                      // console.log(this.invoiceTitle)
                    })
                  }
                });
                this.changeLeg(res.data.subjectOfLegalAffairsId);
                this.changeTicketType(this.formQuery.details[0].invoiceDetailList[0].ticketTypeId, '', 0)
                this.GetTicketTypeForInvoice(this.formQuery.subjectOfLegalAffairsId, this.formQuery.details[0].invoiceDetailList[0], 0);
                this.getInvPrice(0, 'edit')
                this.finalStatement[0].list = res.data.finalStatement;
                this.$nextTick(() => {
                  this.formQuery.details[0].invoiceForFinalStatementsList.forEach(
                    (row) => {
                      this.$refs.multipleTable[0].toggleRowSelection(
                        this.finalStatement[0].list.find((item) => {
                          return row.finalStatementId == item.finalStatementId;
                        }),
                        true
                      );
                    }
                  );
                });
              } else {
                if (res.data.invoiceTitles == 1) {
                  this.formQuery.details[0].accountNumber = res.data.accountNumber;
                  this.formQuery.details[0].bankOfDeposit = res.data.bankOfDeposit;
                  this.formQuery.details[0].businessAddress = res.data.businessAddress;
                  this.formQuery.details[0].invoiceTitle = res.data.invoiceTitle;
                  this.invoiceTitle = {
                    id: this.formQuery.details[0].invoiceTitle,
                  };
                  this.formQuery.details[0].telephone = res.data.telephone;
                  this.formQuery.details[0].ratepayerNo = res.data.ratepayerNo;
                }
                this.formQuery.details[0].newEmail = res.data.newEmail;
                this.formQuery.details[0].projectEmailIds = res.data.projectEmailIds;
                this.formQuery.subjectOfLegalAffairsId =
                  res.data.subjectOfLegalAffairsId;
                if (res.data.subjectOfLegalAffairsId) {
                  this.changeLeg(res.data.subjectOfLegalAffairsId);
                }

                this.finalStatement[0].list.forEach((element) => {
                  this.$set(element, "ttAmount", 0);
                });
                this.handleSelectionChange(this.finalStatement[0].list, 0)
                this.$refs.multipleTable[0].toggleAllSelection()
                // console.log(this.formQuery)
              }
            }
          });
        }
      },
      changeInvoiceTitle(val, inv) {
        if (val.id != undefined && val.id) {
          this.$set(inv, 'invoiceTitle', val.id);
          this.$set(inv, 'accountNumber', val.bankAccount);
          this.$set(inv, 'ratepayerNo', val.account || '');
          this.$set(inv, 'businessAddress', val.businessAddress || '');
          this.$set(inv, 'bankOfDeposit', val.openingBank || '');
          this.$set(inv, 'telephone', val.phoneNum || '');
        }
      },
      //选择主体
      changeLeg(val) {
        if (val && this.jumpType != 'edit') {
          let d = {
            type: this.formQuery.type,
            ownershipId: this.formQuery.ownershipId,
            subjectOfLegalAffairsId: val
          }
          xz.IvoiceFun(d, 'GetInvoiceForSubjectOfContract').then(res => {
            if (res.status == 'ok' && res.data.length > 0) {
              res.data.forEach(element => {
                this.$set(element, 'invoiceDetailsId', '')
                this.$set(element, 'taxInclusiveLabel', 1)
                this.$set(element, 'applyForAmount', 0)
                this.$set(element, 'quantity', null)
                this.$set(element, 'unit', '')
                this.$set(element, 'specification', '')
                this.changeTicketType(element.ticketTypeId, '', 0)
                this.GetTicketTypeForInvoice(this.formQuery.subjectOfLegalAffairsId, res.data, 0);
              });
              this.formQuery.details[0].invoiceDetailList = res.data;
              console.log(this.formQuery.details[0].invoiceDetailList)
            } else {
              this.formQuery.details[0].invoiceDetailList = [{
                invoiceDetailsId: '', //开票申请详细id
                invoiceItem: null, //发票项目
                ticketTypeId: '', //票种id
                billingItemDetailsId: '', //开票内容id
                taxInclusiveLabel: 1, //是否含税1：含税0：不含税
                applyForAmount: 0, //申请金额
                quantity: null, //数量
                unit: '', //单位
                specification: '' //规格
              }]
            }
          })
          // xz.GetBillingItem(val).then((res) => {
          //   if (res.status == "ok") {
          //     this.BillingList = res.data;
          //   } else {
          //     this.BillingList = [];
          //   }
          // });
          // this.GetTicketTypeForInvoice(val);
        }
      },
      //选择开票方式
      changeBilling(val) {
        // console.log(val);
        if (val) {
          this.formQuery.billingItemId = val.key;
          this.businessTypeId = val.businessTypeId;
          this.Billing = val.value;
          xz.GetBillingItemDetails(val.key).then((res) => {
            if (res.status == "ok") {
              this.BillingConList = res.data;
            } else {
              this.BillingConList = [];
            }
          });
          if (val.value.indexOf('差额') > -1) {
            this.formQuery.invoiceTakeOutList = [{
              invoiceTakeOutId: '', //发票项目扣除部分id
              billingItemDetailsId: '', //开票内容（非合并开票时使用
              projectName: '', //固定项目名称：工资、社保、公积金、社保公积金
              newProjectName: '', //自定义项目名称
              deductionAmount: '', //扣除金额
            }]
            const regex = /\((.*?)\)/g;
            const matches = val.value.match(regex);
            let rate = matches.map(match => match.replace(/\(|\)/g, ''))[0];
            rate = rate.replace('%', '');
            this.rate = number(rate) / 100;

          } else {
            this.formQuery.invoiceMain.invoiceAmount = this.settlementAmountSum;
            this.formQuery.invoiceTakeOutList = null;
          }
        }
      },
      down(url, name) {
        var path = this.$store.state.EMP.docPath + url;
        const aTag = document.createElement('a')
        aTag.href = path;
        aTag.download = name;
        aTag.click();
      },
      //选择项目合并
      changePro2(val) {
        if (val) {
          let data = {
            type: 1,
            ownershipId: val,
          };
          xz.IvoiceFun(data, "GetInvoiceLoadEdit").then((res) => {
            if (res.status == "ok") {
              if (this.formQuery.ownershipId != val) {
                if (res.data.finalStatement.length > 0) {
                  this.finalStatement2 = res.data.finalStatement;
                  this.finalStatement2.forEach((element) => {
                    this.$set(element, "ttAmount", 0);
                  });
                } else {
                  this.finalStatement2 = [];
                  this.$message.warning("该项目下暂无结算单");
                }
              } else {
                this.finalStatement2 = [];
                this.$message.error("不能选择同一个项目");
              }
            } else {
              this.finalStatement2 = [];
              this.$message.error(res.msg);
            }
          });
        }
      },
      //选择开票内容
      changeBillingItemDetails(val) {
        if (val.key != undefined && val.key) {
          this.formQuery.invoiceMain.billingItemDetailsId = val.key;
          xz.GetTicketType(val.key, this.formQuery.subjectOfLegalAffairsId).then(
            (res) => {
              if (res.status == "ok") {
                this.ticketTypeList = res.data;
              } else {
                this.ticketTypeList = [];
              }
            }
          );
        }
      },
      changeNewTitle(val, inv) {
        if (val != undefined && val) {
          inv.invoiceTitle = '';
          this.invoiceTitle = '';
        }
        // console.log(val, this.formQuery)
      },
      //选择开票内容
      changeBillingItemDetails2(val) {
        if (val != undefined && val) {
          xz.GetTicketType(val, this.formQuery.subjectOfLegalAffairsId).then(
            (res) => {
              if (res.status == "ok") {
                this.ticketTypeList2 = res.data;
              } else {
                this.ticketTypeList2 = [];
              }
            }
          );
        }
      },
      changeEmail(val) {
        console.log(val);
      },
      changeTicketTypeId(val) {
        if (val.key != undefined && val.key) {
          this.formQuery.invoiceMain.typeInvoice = val.key;
          // if (val.value.indexOf('数电') > -1 && this.jumpType == 'noApply') {
          // this.getLogin()
          // }
        }
      },
      //保存 /提交申请
      submit(status) {
        // console.log(this.formQuery)
        this.$refs.statementForm.validate((valid) => {
          if (valid) {
            if (this.formQuery.details[0].invoiceTitle || this.formQuery.details[0].newInvoiceTitle) {
              let canSubmit = true;
              this.formQuery.details.forEach((element, index) => {
                element.invoiceDetailList.forEach((e, i) => {
                  if (!e.invoiceItem || !e.ticketTypeId || !e.billingItemDetailsId || e.applyForAmount <= 0) {
                    canSubmit = false;
                  }
                  if (index == this.formQuery.details.length - 1 && i == element.invoiceDetailList.length - 1) {
                    if (canSubmit) {
                      this.confirmSubmit(status)
                    } else {
                      this.$message.warning('第二步开票内容不完整，请完善开票内容')
                    }
                  }
                });
              });
            } else {
              this.$message.warning('请选择开票抬头')
            }
          }
        })
      },
      confirmSubmit(status) {
        this.isBtnLoading = true;
        this.formQuery.status = status;
        xz.IvoiceFun(this.formQuery, "SetInvoiceSave").then((res) => {
          if (res.status == "ok") {
            this.$message.success(status == 1 ? "保存成功" : "提交申请成功！");
            this.isBtnLoading = false;
            this.isSuccess = true;
            setTimeout(() => {
              this.backHandle()
            }, 1000);
          } else {
            this.$message.error(res.msg);
            this.isBtnLoading = false;
          }
        });
      },
      //发票申请修改获取详情
      GetInvoiceEdit() {
        xz.GetInvoiceEdit(this.id).then((res) => {
          if (res.status == "ok") {
            // this.formQuery = res.data[0];
            let r = res.data[0];
            r.invoiceDetailList.forEach(element => {
              element.invoiceItem = number(element.invoiceItem);
              if (!element.unit) {
                element.unit = '';
              }
              if (!element.specification) {
                element.specification = '';
              }
            });
            console.log('dsa', r.invoiceDetailList)
            this.formQuery = {
              type: r.type,
              ownershipId: r.ownershipId, //归属id
              subjectOfLegalAffairsId: r.subjectOfLegalAffairsId, //开票主体id
              details: [{
                isNaturalPerson: r.isNaturalPerson,
                invoiceTitle: r.invoiceTitle, //开票抬头id
                newInvoiceTitle: r.newInvoiceTitle, //新开票抬头
                ratepayerNo: r.ratepayerNo, //纳税人识别号
                businessAddress: r.businessAddress, //营业地址
                bankOfDeposit: r.bankOfDeposit, //开户行
                accountNumber: r.accountNumber, //账号
                telephone: r.telephone, //电话
                isConsolidatedBilling: r.isConsolidatedBilling, //是否合并开票
                isStatementMail: r.isStatementMail, //费用结算单盖章一并邮寄0：否1：是
                isInvoiceMail: r.isInvoiceMail, //是否自动邮件发送电子/数电发票0：否1：是
                remark: r.remark, ////备注
                deductionAmount: r.deductionAmount, //客户扣款金额
                newEmail: r.newEmail, //新邮箱
                projectEmailIds: r.projectEmailIds,
                invoiceFiles: r.invoiceFiles,
                invoiceId: this.id, ////发票id
                billingNote: '', //开票备注
                invoiceForFinalStatementsList: r.invoiceForFinalStatementsList,
                invoiceDetailList: r.invoiceDetailList,
              }],
              status: 0, //状态 0申请提交 1申请保存 2开票提交
              founder: Cookies.get("userid-b"), //创建人
            };
            if (this.formQuery.xAccount == undefined) {
              this.formQuery.xAccount = {
                accountType: 0, //账户类别0：基本户1：一般户
                openingBank: '',
                bankAccount: '',
              }
            }
            this.formQuery.ownershipId = Number(this.formQuery.ownershipId);
            this.getDetail("edit");
            // if (this.formQuery.subjectOfLegalAffairsId) {
            //   this.changeLeg(this.formQuery.subjectOfLegalAffairsId);
            // }
            //   setTimeout(() => {
            //     this.BillingList.forEach((element) => {
            //       if (this.formQuery.billingItemId == element.key) {
            //         this.Billing2 = element;
            //         this.changeBilling(this.Billing2);
            //         this.billingItemDetails = {
            //           key: this.formQuery.invoiceMain.billingItemDetailsId,
            //         };
            //         this.settlementAmountSum =
            //           this.formQuery.invoiceMain.invoiceAmount;
            //       }
            //     });
            //   }, 2000);
            //   setTimeout(() => {
            //     this.changeBillingItemDetails(this.billingItemDetails);
            //   }, 4000);
          }
        });
      },
      confirmLogin() {

      },
      changeEwmlx() {
        this.QRCodeSrc = '';
        this.getQRCode();
      },
      getQRCode() {
        this.qrLoading = true;
        let data = {
          nsrsbh: this.loginForm.nsrsbh,
          areaid: this.loginForm.areaid,
          ewmlx: this.ewmlx
        }
        xz.IvoiceFun(data, 'PostThirdParty_queryAuthQrCode').then(res => {
          if (res.status == 'ok') {
            this.qrLoading = false;
            this.QRCodeSrc = res.data.ewm;
            this.showAuthentication = true;
            this.times = 0;
            setTimeout(() => {
              this.getQRStatus(res.data.rzid);
            }, 20000);
          } else {}
        })
      },
      //获取扫码情况
      getQRStatus(id) {
        this.times++;
        xz.PostThirdParty_queryAuthQrCode(id).then(res => {
          if (res.status == 'ok') {
            if (res.rzzt == '2') {
              this.showAuthentication = false;
              this.$message.success('认证成功');
            } else if (res.rzzt == '3') {
              this.$message.success('认证超时');
            } else if (res.rzzt == '1' && this.times < 59) {
              setTimeout(() => {
                this.getQRStatus(id)
              }, 2000);
            }
          } else {
            if (this.times < 59) {
              setTimeout(() => {
                this.getQRStatus(id)
              }, 2000);
            }
          }
        })
      },
      addKcItem() {
        let data = {
          invoiceTakeOutId: '', //发票项目扣除部分id
          billingItemDetailsId: this.formQuery.invoiceTakeOutList[0].billingItemDetailsId, //开票内容（非合并开票时使用
          projectName: '', //固定项目名称：工资、社保、公积金、社保公积金
          newProjectName: '', //自定义项目名称
          deductionAmount: '', //扣除金额
        }
        this.formQuery.invoiceTakeOutList.push(data)
      },
      delKcItem(index) {
        this.formQuery.invoiceTakeOutList.splice(index, 1)
      },
      //获取票种
      GetTicketTypeForInvoice(id, row, i) {
        let iskc;
        if (row.invoiceItem < 0 || this.formQuery.details[i].isConsolidatedBilling == 1) {
          iskc = true
        } else {
          iskc = false;
        }
        xz.GetTicketTypeForInvoice(id, iskc).then(res => {
          if (res.status == 'ok') {
            this.ticketTypeList = res.data
          } else {
            this.ticketTypeList = [];
          }
        })
      },
      //选择票种
      changeTicketType(val, row, i) {
        if (row != '') {
          this.$set(row, 'billingItemDetailsId', '');
        } else {
          row = this.formQuery.details[0].invoiceDetailList[0];
        }
        let iskc;
        console.log(i)
        if (row.invoiceItem < 0 || this.formQuery.details[i].isConsolidatedBilling == 1) {
          iskc = true
        } else {
          iskc = false;
        }
        xz.GetBillingItemDetailsForInvoice(this.formQuery.subjectOfLegalAffairsId, val, this.formQuery.ownershipId, iskc).then(res => {
          if (res.status == 'ok') {
            this.BillingConList = res.data;

            this.formQuery.details[i].invoiceDetailList.forEach(element => {
              this.changeBillingItemDetailsId(element.billingItemDetailsId, element, i)
            })
          } else {
            this.BillingConList = [];
          }
        })
      },
      //在申请一张
      applyMore() {
        this.invoiceTitle.push(this.invoiceTitle[0]);
        this.settlementAmountSum.push({
          sum: 0
        });
        this.applyForAmount.push({
          sum: 0
        });
        this.finalStatement.push({
          list: JSON.parse(JSON.stringify(this.finalStatement[0].list))
        })
        let model = JSON.parse(JSON.stringify(this.formQuery.details[0]));
        let data = {
          invoiceTitle: model.invoiceTitle, //开票抬头id
          newInvoiceTitle: model.newInvoiceTitle, //新开票抬头
          ratepayerNo: model.ratepayerNo, //纳税人识别号
          businessAddress: model.businessAddress, //营业地址
          bankOfDeposit: model.bankOfDeposit, //开户行
          accountNumber: model.accountNumber, //账号
          telephone: model.telephone, //电话
          isConsolidatedBilling: 0, //是否合并开票
          isStatementMail: 0, //费用结算单盖章一并邮寄0：否1：是
          isInvoiceMail: 0, //是否自动邮件发送电子/数电发票0：否1：是
          remark: "", ////备注
          deductionAmount: 0, //客户扣款金额
          newEmail: "", //新邮箱
          projectEmailIds: [
            //发票邮箱集合
          ],
          invoiceFiles: [
            //发票结算单文件地址
          ],
          buildingData: { //建筑服务补充信息
            landValueTaxNo: "", //土地增值税项目编号
            buildingServiceSite: "", //建筑服务发生地
            detailedAddress: "", //详细地址
            buildingName: "", //建筑项目名称
            crossCitySigns: 1 //跨地市标志1:是0：否
          },
          invoiceId: "", ////发票id
          billingNote: '', //开票备注
          invoiceForFinalStatementsList: [{
            //关联结算单
            finalStatementId: "", //
            amount: 0,
            invoiceForFinalStatementId: '', //结算单关联id
          }],
          invoiceDetailList: [{
            invoiceDetailsId: '', //开票申请详细id
            invoiceItem: null, //发票项目
            ticketTypeId: '', //票种id
            billingItemDetailsId: '', //开票内容id
            taxInclusiveLabel: 1, //是否含税1：含税0：不含税
            applyForAmount: 0, //申请金额
            quantity: null, //数量
            unit: '', //单位
            specification: '' //规格
          }],
        }
        this.viewBuild.push(false)
        this.formQuery.details.push(data);
        let i = this.formQuery.details.length - 1;
        setTimeout(() => {
          this.handleSelectionChange(this.finalStatement[i].list, i);
          this.$refs.multipleTable[i].toggleAllSelection()
        }, 1000);
      },
      getInvPrice(i, type) {
        let sum = 0;
        this.formQuery.details[i].invoiceDetailList.forEach((element, index) => {
          if (element.taxInclusiveLabel == 1 || element.invoiceItem < 0) {
            sum = Number(sum) + Number(element.applyForAmount)
          } else {
            // console.log('1', element.applyForAmount, element.applyForAmount, element.taxRate)
            sum = Number(sum) + Number(element.applyForAmount) + element.applyForAmount * element.taxRate
          }
          if (index == this.formQuery.details[i].invoiceDetailList.length - 1) {
            this.applyForAmount[i].sum = sum.toFixed(2);
            if (this.finalStatement[i].list.length == 1) {
              this.finalStatement[i].list[0].ttAmount = sum.toFixed(2);
              if (type != 'edit') {
                this.changeTTAmount(i);
              }
            }
          }
        });
      },
      changeBillingItemDetailsId(val, row, i) {
        this.BillingConList.forEach(element => {
          if (element.key == val) {
            if (element.value.indexOf('*建筑服务*') > -1) {
              this.viewBuild[i] = true;
            }
            this.$set(row, 'taxRate', element.taxRate);
            this.getInvPrice(i, 'ccc')
          }
        });
      },
      changeTaxInc(val, i) {
        this.getInvPrice(i, 'ccc')
      },
      changeInvoiceItem(val, row, i) {
        this.$set(row, 'billingItemDetailsId', '');
        this.$set(row, 'ticketTypeId', '');
        this.GetTicketTypeForInvoice(this.formQuery.subjectOfLegalAffairsId, row, i);
      },
      //发票预览
      invView(i) {
        console.log(this.formQuery.details)
        if (this.formQuery.subjectOfLegalAffairsId) {
          if (!this.xsInfo.ratepayerNo) {
            xz.GetCorporationData(this.formQuery.subjectOfLegalAffairsId).then((res) => {
              if (res.status == "ok") {
                this.xsInfo = {
                  title: res.data.strLegalsubName,
                  ratepayerNo: res.data.taxNum
                }
              }
            })
          }
          this.invViewInfo = [];
          this.formQuery.details[i].invoiceDetailList.forEach((e, index) => {

          });
          this.showInvView = true;
        } else {
          this.$message.warning('请先选择商务合同主体')
        }
      },
      changeIsp(val, i) {
        if (val) {
          this.formQuery.details[i].newInvoiceTitle = '个人';
          this.invoiceTitle[i] = '';
          this.formQuery.details[i].invoiceTitle = '';
          this.formQuery.details[i].accountNumber = '';
          this.formQuery.details[i].ratepayerNo = '';
          this.formQuery.details[i].businessAddress = '';
          this.formQuery.details[i].bankOfDeposit = '';
          this.formQuery.details[i].telephone = '';
        } else {
          this.formQuery.details[i].newInvoiceTitle = '';
        }
      },
      delItem() {
        this.formQuery.details.splice(this.formQuery.details.length - 1, 1);
        this.$message.success('删除成功！')
      },
      changeAccountType() {
        if (this.formQuery.xAccount.accountType == 1) {
          let d = {
            keyWord: "",
            pageSize: 100,
            legalsubid: this.formQuery.subjectOfLegalAffairsId,
            UserId: Cookies.get("userid-b")
          }
          xz.BasicFun(d, "GetGeneralAccount").then((res) => {
            if (res.status == "ok") {
              this.accountList = res.data;
            } else {
              accountList = [];
            }
          });
        } else {
          this.formQuery.xAccount.bankAccount = '';
          this.formQuery.xAccount.openingBank = '';
        }
      },
      changeBankAccount(val) {
        let item = this.accountList.find(e => e.value == val);
        this.formQuery.xAccount.openingBank = item.key;
        console.log(this.formQuery.xAccount)
      },
      changeConsolidatedBilling(val, inv) {
        let arr = [{
          invoiceDetailsId: '', //开票申请详细id
          invoiceItem: null, //发票项目
          ticketTypeId: '', //票种id
          billingItemDetailsId: '', //开票内容id
          taxInclusiveLabel: 1, //是否含税1：含税0：不含税
          applyForAmount: 0, //申请金额
          quantity: null, //数量
          unit: '', //单位
          specification: '' //规格
        }]
        this.$set(inv, 'invoiceDetailList', arr)
      }
    },
  };
</script>
<style scoped>
  .f_foot_box {
    font-size: 14px;
    color: #555;
  }

  .flex_box {
    /* justify-content: space-around; */
    flex-wrap: wrap;
    padding-left: 15px;
  }

  .f_foot_box,
  .f_foot {
    align-items: center;
  }

  .t_sel {
    margin-left: 15px;
  }

  .f_foot {
    margin-left: 40px;
  }

  .foot_left_box {
    width: 80px;
  }

  .f_sel01 {
    margin-right: 10px;
  }

  .f_com_box {
    padding: 20px 5px;
  }

  .f_icon {
    font-size: 20px;
    color: #19bd92;
  }

  .f_list_box {
    margin-right: 80px;
    align-items: center;
    font-size: 14px;
    color: #555;
  }

  .f_left_box {
    text-align: right;
    width: 100px;
    margin-right: 5px;
  }

  .f_right_box {
    flex: 1;
  }

  .add_box {
    align-items: center;
    margin-top: 15px;
  }

  .btn01 {
    margin-left: 10px;
  }

  .mt15 {
    margin-top: 15px;
  }

  .pt20 {
    padding-top: 20px;
  }

  .com_style {
    background-color: #e8f7f7;
  }

  .i_radio_box {
    display: -webkit-box;
    /* align-items: center; */
  }

  .i_box {
    margin-left: 30px;
  }

  .print_box {
    justify-content: flex-end;
  }

  .com_form_box {
    margin: 15px 0;
  }

  .d_txt {
    font-size: 14px;
    color: #555;
    margin-top: 20px;
  }

  .btn_box {
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }

  .line_box {
    width: 3px;
    height: 16px;
    background-color: #19bd92;
    margin-right: 4px;
  }

  .dtl_table {
    box-sizing: border-box;
    margin-top: 15px;
  }

  .emp_txt {
    width: 90px;
    text-align: right;
    font-size: 14px;
    color: #555;
    padding: 0 10px 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .tips {
    color: #598DE7;
    font-size: 13px;
    margin-left: 20px;
  }

  .r_edit_title {
    display: flex;
    align-items: center;
    font-size: 16px;
    line-height: 26px;
    font-weight: bold;
    color: #000;
    /* border-bottom: 1px solid #DCDFE6; */
  }

  .emp_form_txt {
    width: 370px;
    font-size: 14px;
    color: #000;
  }

  .txts01 {
    font-size: 14px;
  }

  .p_employee_item {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    margin-right: 3px;
  }

  .p_employee_form.p_employee_form01 {
    margin-top: 0;
  }

  .p_employee_form {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
  }

  .p_employee_box {
    background-color: #fff;
    padding: 15px 10px;
  }

  .qrTips {
    text-align: center;
    font-size: 14px;
    color: red;
    margin-top: 10px;
  }

  .ceBox {
    padding-left: 30px;
    padding-bottom: 20px;
  }

  .ceTitle {
    font-weight: bold;
    font-size: 14px;
    padding-top: 9px;
  }

  .ckbox {
    margin-left: 120px;
    margin-bottom: 10px;
  }

  .ckbox2 {
    margin-left: 40px;
    margin-bottom: 10px;
  }

  .huo {
    line-height: 32px;
    margin: 0 10px;
    font-size: 14px;
  }

  .blueName {
    line-height: 32px;
  }

  .req {
    color: red;
    margin-right: 3px;
  }

  .redTips {
    color: red;
    font-size: 13px;
    margin-left: 20px;
  }

  .merge {
    padding: 10px 30px;
  }

  .sumAmount {
    font-weight: bold;
    margin-left: 600px;
    padding-bottom: 15px;
  }

  .applyMore {
    font-size: 18px;
    font-weight: bold;
    margin-left: 30px;
  }

  .splitLine {
    width: 100%;
    border-top: #CCC 2px dashed;
    margin-bottom: 25px;
  }

  .kptip {
    color: #598DE7;
    margin-top: 10px;
    padding-left: 30px;
  }

  .tabBox {
    background: #fff;
    padding: 30px;
    /* width: 800px; */
  }

  .invTitle {
    width: 800px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .reimbursementTitle {
    text-align: center;
    margin-bottom: 3px;
    font-size: 24px;
    color: #800000;
  }

  .invType {
    margin-left: 30px;
    font-size: 14px;
    color: #000;
    min-width: 150px;
  }

  .invNum {
    color: #800000;
    margin-bottom: 5px;
  }

  .centerTitle {
    margin-bottom: 5px;
    font-size: 20px;
  }

  .invoiceTable {
    margin-top: 10px;
    width: 800px;
    background-color: #fff;
    padding: 8px 0;
    /* line-height: 40px; */
  }

  .tabBox table td,
  .tabBox table th {
    border: #800000 1px solid !important;
  }

  .tabBox table {
    border: #800000 1px solid !important;
  }

  .tabBox_title {
    background: #f6f6f6;
  }

  .font-center {
    text-align: center
  }

  .titfont {
    font-family: 微软雅黑;
    padding: 10px 0;
    color: #800000;
  }

  .titfont2 {
    padding: 20px 0;
  }

  .rowItem {
    font-size: 14px;
    padding-left: 5px;
  }

  .mt {
    margin-top: 30px;
  }

  .rowTitle {
    font-size: 13px;
    color: #800000;
  }

  .invInfoBox {
    height: 180px;
    padding: 5px 0;
    position: relative;
  }

  .invItem {
    width: 100px;
    text-align: center;
    color: #800000;
  }

  .invInfoLine {
    margin-top: 5px;
    color: #000;
  }

  .invInfoItem {
    text-align: center;
    width: 100px;
  }

  .invInfoBot {
    position: absolute;
    bottom: 5px;
  }

  .amountLine {
    line-height: 32px;
  }

  .invRemake {
    margin-left: 5px;
  }

  /* 水印 */
  .invInfoBox::before {
    content: "仅供开票预览";
    position: absolute;
    top: 12%;
    left: 24%;
    transform: translate(-50%, -50%);
    transform: rotate(30deg);
    opacity: 0.4;
    letter-spacing: 20px;
    font-size: 54px;
    color: #ccc;
    position: none;
  }

  .delete_icon {
    font-size: 20px;
  }

  .deleteBtn {
    line-height: 32px;
  }
</style>
<style>
  .page_updateInvoice .f_sel_box .el-select {
    width: 150px;
  }

  .page_updateInvoice .dtl_table .el-table,
  .page_updateInvoice .dtl_table .el-table th.el-table__cell,
  .i_list.el-table tr {
    background-color: #e8f7f7;
    /* 你想要的背景色 */
  }

  .form_table td {
    border: #000 1px solid;
  }

  .e_dtl_content .el-table .el-table__cell {
    padding: 4px 0;
  }

  .page_updateInvoice .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_updateInvoice .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_updateInvoice .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_updateInvoice .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_updateInvoice .el-radio {
    margin-right: 15px;
  }
</style>